export default "__VITE_ASSET__24f7b339__"